<template>
  <div class="home">
    欢迎来到 胖球的跑步实验室<br>这里有我开发的一些工具，以及我对跑步的分享和思考<br>希望对你有用!
  </div>
</template>

<script>
export default {
  name: "HomePage"
};
</script>
<style scoped>
.home {
  position:absolute;
  top:40%;
  left:50%;
  transform: translate(-50%, -50%);
  font-size:32px;
  color:#777;
  line-height:68px;
  white-space:nowrap;
}
@media only screen and (max-width: 768px) {
  .home {font-size:14px; line-height:32px;}
}
</style>